export enum RentalManagementTypeEnum {
  SelfManaged = 'SelfManaged',
  Agency = 'Agency',
}
